import { MUST_OUT, MUST_IN, ON_ERROR } from '../types/AuthenticationTypes';

export const mustOut = () => {
  return { type: MUST_OUT };
};

export const mustIn = () => {
  return { type: MUST_IN };
};

export const onError = () => {
  return { type: ON_ERROR };
};
